import getListenerOptions from "../get-listener-options"

export default {
  init: function () {
    const t = this
    
    t.header = document.querySelector(".header")
    t.mainNav = t.header.querySelector(".main-nav")

    if (!t.mainNav) return

    t.onScroll = t.onScroll.bind(t)
    t.headerIsSticky = false
    document.addEventListener("scroll", t.onScroll, getListenerOptions())
    t.onScroll()
   
    // t.toggleIcons = [...t.toggleEl.querySelectorAll("svg")]

    t.allSubmenus = [...document.querySelectorAll(".sub-menu")]
    t.attachTriggerClick = t.attachTriggerClick.bind(t)
    t.allSubmenus.forEach(t.attachTriggerClick)

    t.toggleEl = document.getElementById("menu-toggle")
    t.openCloseMobileNav = t.openCloseMobileNav.bind(t)
    t.onTouchOutside = t.onTouchOutside.bind(t)
    t.toggleEl.addEventListener("touchstart", t.openCloseMobileNav, false)

    t.onSubmenuOpen = t.onSubmenuOpen.bind(t)
    t.onSubmenuClose = t.onSubmenuClose.bind(t)

    t.navByTab = t.navByTab.bind(t)
    ;[...t.mainNav.querySelectorAll("a, button")].forEach(t.navByTab)

    t.onMenuScroll = t.onMenuScroll.bind(t)
    t.menuTop = t.mainNav.querySelector(".menu-to-top")
    t.menuPhone = t.mainNav.querySelector(".menu-phone")
    t.menuTopActive = false
    t.menuPhoneActive = true
    t.onMenuButtonsClick()
    t.mainNav.addEventListener("scroll", t.onMenuScroll, getListenerOptions())

    if ("ResizeObserver" in window) {
      new ResizeObserver((entries) => {
        t.onMenuResize(entries[0].target)
      }).observe(t.mainNav)
    }
  },

  onScroll: function() {
    const t = this

    if (window.scrollY > 0) {
      if (!t.headerIsSticky) {
        t.header.classList.add("bg-white", "shadow-header")
        t.headerIsSticky = true
      }
    } else if (t.headerIsSticky) {
      t.header.classList.remove("bg-white", "shadow-header")
      t.headerIsSticky = false
    }
  },

  onMenuScroll: function({target}) {
    const t = this
    const scrollY = Math.round(target.scrollTop + target.offsetHeight)
    const height = target.scrollHeight - 1

    if (scrollY >= height) {
      if (!t.menuTopActive) {
        t.menuTop.classList.remove("invisible", "-z-1")
        t.menuPhone.classList.add("invisible", "-z-1")
        t.menuTopActive = true
      }
    } else if (t.menuTopActive) {
      t.menuTop.classList.add("invisible", "-z-1")
      t.menuPhone.classList.remove("invisible", "-z-1")
      t.menuTopActive = false
    }
  },

  onMenuResize: function(target) {
    const t = this
    ;[t.menuTop, t.menuPhone].forEach((btn) => {
      btn.classList[target.offsetHeight >= target.scrollHeight ? "add" : "remove"]("hidden")
    })
  },

  onMenuButtonsClick: function() {
    const t = this
    ;[t.menuTop, t.menuPhone].forEach((btn, i) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault()

        if (i == 0) {
          window.scrollTo({top: 0, behavior: 'smooth'})
        }
  
        t.mainNav.scrollTo({
          top: (i == 0 ? 0 : t.mainNav.scrollHeight),
          behavior: 'smooth'
        })
      })
    })
  },

  isExpanded: function (t) {
    return t.getAttribute("aria-expanded") == "true"
  },

  toggleExpanded: function (trigger, isOpen) {
    trigger.setAttribute("aria-expanded", isOpen ? "false" : "true")
  },

  openCloseMobileNav: function () {
    const t = this
    const isOpen = t.isExpanded(t.toggleEl)

    t.toggleExpanded(t.toggleEl, isOpen)

    const classes = ["mobile-menu-open"]
    if (!(isOpen && window.scrollY > 0)) {
      classes.push("bg-white")
    }

    t.header.classList[isOpen ? "remove" : "add"](...classes)

    if (isOpen) {
      t.closeOpenedSubMenus()
    }

    t.onMenuResize(t.mainNav)
  },

  openCloseSubMenu: function (trigger, chained = true) {
    const t = this
    const subMenuEl = trigger.nextElementSibling

    if (subMenuEl) {
      // const caretEl = trigger.querySelector("svg")

      const child = subMenuEl.children[0]
      const childRect = child.getBoundingClientRect()
      subMenuEl.style.height = `${childRect.height}px`

      const isOpen = t.isExpanded(trigger)
      t.toggleExpanded(trigger, isOpen)

      if (isOpen) {
        // caretEl.classList.remove("transfrom", "-rotate-180")

        setTimeout(() => {
          subMenuEl.style.height = 0

          subMenuEl.addEventListener(
            "transitionend",
            t.onSubmenuClose,
            getListenerOptions(),
          )
        }, 16)
      } else {
        subMenuEl.addEventListener(
          "transitionend",
          t.onSubmenuOpen,
          getListenerOptions(),
        )
        //   caretEl.classList.add("transfrom", "-rotate-180")
      }
    }

    if (chained) {
      t.closeOpenedSubMenus(
        t.allSubmenus.filter(
          (s) =>
            s != subMenuEl
            && trigger.closest(".sub-menu") !== s
            && !trigger.closest(".sub-menu--deep")
        ),
      )
    }
  },

  closeOpenedSubMenus: function (subs) {
    const t = this

    ;(subs || t.allSubmenus)
    .forEach((s) => t.isExpanded(s.previousElementSibling) && t.openCloseSubMenu(s.previousElementSibling, false))
  },

  onSubmenuOpen: function (e) {
    const t = this
    const subMenu = e.target

    subMenu.style.height = "auto"

    subMenu.removeEventListener(
      "transitionend",
      t.onSubmenuOpen,
    )

    if (window.innerWidth !== t.mainNav.offsetWidth) { // check if the menu is not in the mobile mode
      ;["touchstart", "touchstart"].forEach((ev) => {
        document.addEventListener(
          ev,
          t.onTouchOutside
        )
      })
    }

    t.onMenuResize(t.mainNav)
  },

  onSubmenuClose: function(e) {
    const t = this
    
    e.target.removeEventListener(
      "transitionend",
      t.onSubmenuClose,
    )

    t.onMenuResize(t.mainNav)
  },

  onTouchOutside: function() {
    const t = this

    t.closeOpenedSubMenus()

    document.removeEventListener(
      "touchstart",
      t.onTouchOutside
    )
  },

  attachTriggerClick: function(subMenu) {
    const t = this
    const trigger = subMenu.previousElementSibling

    trigger.addEventListener(
      "touchstart",
      (e) => {
        e.preventDefault()
        t.openCloseSubMenu(trigger)
      },
      false,
    )
  },

  navByTab: function(trigger) {
    const t = this
    let mouseDown = false

    trigger.addEventListener(
      "mousedown",
      () => (mouseDown = true),
      false,
    )
    trigger.addEventListener(
      "mouseup",
      () => (mouseDown = false),
      false,
    )

    trigger.addEventListener(
      "focus",
      (e) => !mouseDown && t.openCloseSubMenu(e.currentTarget),
      false,
    )
  }
}